<template>
  <div id="app">
    <a-config-provider :theme="customTheme" :locale="zhCN">
      <router-view />
    </a-config-provider>
  </div>
</template>

<script>
import { theme } from "ant-design-vue";
import 'dayjs/locale/zh-cn';
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'

// 设置 dayjs 本地化（用于日期组件）
dayjs.locale('zh-cn')

const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
};

export default {
  name: "App",
  data() {
    return {
      zhCN,
      customTheme: {
        token: {
          colorPrimary: "#dcb48a",
          colorInfo: "#dcb48a",
          wireframe: false,
        },
        algorithm: [],
      },
    };
  },
  watch: {
    "vuex_client_config.systemTheme"() {
      this.changeTheme();
    },
  },
  mounted() {
    // 设置主题
    this.changeTheme();
    this.$router.isReady().then(() => {
      if (this.$route.path.startsWith("/basic/")) {
        let searchParams = new URLSearchParams(this.$route.query).toString();
        this.$router.replace({
          path: "/",
          query: {
            path: this.$route.path + (searchParams ? `?${searchParams}` : ""),
          },
        });
      }
    });
  },
  methods: {
    /**
     * 切换主题样式
     */
    changeTheme() {
      let systemTheme = this.vuex_client_config.systemTheme;
      if (systemTheme === "light") {
        this.customTheme.algorithm.push(theme.defaultAlgorithm);
      } else if (systemTheme === "dark") {
        this.customTheme.algorithm.push(theme.darkAlgorithm);
      }
    },
  },
};
</script>

<style lang="less"></style>
